import { agentsColumns, tableViewNames } from '../../../../agent-production/constants/agentProductionConstants';
import { transactionCoveragePDFColumns } from '../../../../agent-production/constants/pdfColumns';
import { colSettings } from '../agGrid/colSettings';

export const createTransactionCoveragePDFView = (selectedAreaLabel) => ({
    id: tableViewNames.transactionCoveragePDF,
    tables: [
        { col: transactionCoveragePDFColumns.rank, colDef: colSettings.textSm },
        { col: { ...transactionCoveragePDFColumns.area, label: selectedAreaLabel }, colDef: colSettings.textSmRightAlign },
        { col: transactionCoveragePDFColumns.totalUnits, colDef: colSettings.numberSmUnits },
        { col: transactionCoveragePDFColumns.totalVolume, colDef: colSettings.numberSmVolume },
        { col: transactionCoveragePDFColumns.totalUnitsPct, colDef: colSettings.numberSmPercentage },
        { col: transactionCoveragePDFColumns.totalVolumePct, colDef: colSettings.numberSmPercentage },
    ]
});

export const inventoryView = {
    id: tableViewNames.inventory,
    tables: [
        { col: agentsColumns.mlsNum, colDef: colSettings.textSm },
        { col: agentsColumns.statusCode, colDef: colSettings.textSm },
        { col: agentsColumns.typeName, colDef: colSettings.textSm },
        { col: agentsColumns.address, colDef: colSettings.textMd },
        { col: agentsColumns.contract, colDef: colSettings.numberSmInteger },
        { col: agentsColumns.cdom, colDef: colSettings.numberSmInteger },
        { col: agentsColumns.orgPrice, colDef: colSettings.numberMdVolume },
        { col: agentsColumns.listPrice, colDef: colSettings.numberMdVolume },
        { col: agentsColumns.priceChangeCnt, colDef: colSettings.numberMdInteger },
    ],
};
